import { render, staticRenderFns } from "./custom-table-footer.vue?vue&type=template&id=615d582e&scoped=true"
import script from "./custom-table-footer.vue?vue&type=script&lang=js"
export * from "./custom-table-footer.vue?vue&type=script&lang=js"
import style0 from "./custom-table-footer.vue?vue&type=style&index=0&id=615d582e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615d582e",
  null
  
)

export default component.exports